import { analytics, EEVENT_LABEL } from 'affiny-core/analytics';
import { Box, rem, Text } from 'affiny-ui/src';
import React, { memo, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

interface IFooterLink {
  label: string;
  url?: string;
  isLastItem: boolean;
  eventLabel: EEVENT_LABEL;
  additionalCallback?: string;
}

declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    MgCookiePolicy: {
      openPreferenceCenter: () => void;
    };
  }
}

export const FooterLink = memo(
  ({ label, url, isLastItem, eventLabel, additionalCallback }: IFooterLink) => {
    const history = useHistory();
    const handleItemClick = useCallback(() => {
      analytics.trackEvent(eventLabel);

      switch (additionalCallback) {
        case 'window.MgCookiePolicy.openPreferenceCenter':
          if (process.env.NODE_ENV !== 'development') {
            window.MgCookiePolicy.openPreferenceCenter();
          } else {
            history.push('/settings/cookies');
          }
          break;
      }
    }, [eventLabel, additionalCallback, history]);

    const contentItem = (
      <Box>
        <Text
          color="secondary"
          lineHeight={rem(19)}
          fontSize={['size12', 'size14']}
        >
          {label}
        </Text>
      </Box>
    );

    return (
      <>
        {url ? (
          <Link to={url} onClick={handleItemClick}>
            {contentItem}
          </Link>
        ) : (
          <Box onClick={handleItemClick} cursor="pointer">
            {contentItem}
          </Box>
        )}

        {!isLastItem && (
          <Text
            color="secondary"
            lineHeight={rem(19)}
            fontSize={['size12', 'size14']}
          >
            |
          </Text>
        )}
      </>
    );
  }
);
